import { RadioButtonChecked } from "@material-ui/icons";
import React, { FC }          from "react";
import { useDrag }            from "react-dnd";
import { Card }               from "semantic-ui-react";
import WidgetType             from "../../../../../domain/record/widget/WidgetType";

const CarouselRadioHorizontalWidget: FC = () => {
  const [{isDragging}, drag] = useDrag({
    item: {widgetIndex: NaN, type: WidgetType.RADIO_HORIZONTAL},
    collect: monitor => ({isDragging: monitor.isDragging()})
  });

  return (
    <>
      <div ref={ drag } style={ {opacity: isDragging ? 0.5 : 1, cursor: "pointer"} }>
        <Card
          style={ {width: "6rem", height: "6.5rem", padding: 0} }
        >
          <Card.Content textAlign="center">
            <RadioButtonChecked/>
            <Card.Description>ラジオ<br/>横</Card.Description>
          </Card.Content>
        </Card>
      </div>
    </>
  )
};

export default CarouselRadioHorizontalWidget;
